import script from "./RegisterConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./RegisterConfirmation.vue?vue&type=style&index=0&id=20249882&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20249882"]])

export default __exports__